<template>
  <div>
    <el-alert
      v-if="userinfo.balance < 0 && userinfo.force_order == 0"
      title="您的余额为负数，无法委托平台下单，请及时充值"
      type="warning"
      style="margin-bottom:10px;"
      show-icon>
    </el-alert>
    <xcurd :topBtns="topBtns" :dialogs="dialogs" :table="table" @clickRowBtn="" @clickMultiBtn="" @clickTopBtn=""></xcurd>
  </div>
</template>
<script>
import Xcurd from 'xelement/curd'
import ajax from 'xelement/ajax'
import { api } from 'src/config'

let addForm = {
  data: {
    content: '',
    pay_type: '1',
    fitdata: ''
  },
  config: {
    base: {
      labelWidth: '100px'
    },
    submit: {
      btnText: '提交',
      url: api.order.addBefore
    },
    item: [
      [{
        id: 'content',
        title: '内容',
        type: 'textarea',
        config: {
          rows: 3,
          // autosize: true,
          autosize: {
            minRows: 5,
            maxRows: 8
          }
        }
      }],
      [{
        id: 'fitdata',
        title: '安装数据',
        type: 'upload',
        config: {
          action: api.order.upimg,
        }
      }],
      [{
        id: 'pay_type',
        title: '支付方式',
        type: 'radio',
        data: [
          {
            id: '1',
            text: '客户付款'
          },
          {
            id: '2',
            text: '商家付款'
          }
        ],
        config: {
          type: 'btn'
        }
      }]
    ]
  }
};
let editForm = JSON.parse(JSON.stringify(addForm));
editForm.data.id = 0;
editForm.config.submit.url = api.order.editBefore;

export default {
  data() {
    return {
      userinfo: {
        name: '',
        balance: 0,
        force_order: 0
      },
      topBtns: [
        {
          id: 'add',
          text: '委托平台下单',
          icon: 'plus',
          type: 'primary',
          dialog: 'add',
          disabled: false
        }
      ],
      dialogs: [
        {
          id: 'add',
          title: '委托平台下单',
          isClose: true,
          form: addForm
        },
        {
          id: 'edit',
          title: '编辑',
          isClose: true,
          form: editForm
        }
      ],
      table: {
        data: api.order.getBeforeList,
        config: {
          base: {
            showIndex: false
          },
          selection: false,
          expand: [
            {
              title: '订单内容',
              prop: 'content'
            }
          ],
          query: false,
          rowBtns: {
            config: {
              width: '80',
              isFixed: true
            },
            list: [
              {
                id: 'edit',
                icon: 'edit',
                dialog: 'edit'
              }
            ]
          },
          page: true,
          field: [
            {
              id: '_seller.name',
              text: '商家',
              width: '160'
            },
            {
              id: 'pay_type',
              text: '支付方式',
              width: '120',
              formatter: 'payType'
            },
            {
              id: 'time_creat',
              text: '下单时间'
            }
          ]
        }
      }
    }
  },
  created(){
    this.getUserData();
  },
  methods: {
    getUserData(){
      let _self = this;
      ajax(this, 'get', api.account.getUserData, {}, (res) => {
        _self.userinfo.name = res.data.name;
        _self.userinfo.balance = res.data.balance;
        _self.userinfo.force_order = res.data.force_order;
        if(res.data.balance*1 < 0 && res.data.force_order == 0){
          _self.topBtns[0].disabled = true;
        }
      })
    }
  },
  components: {
    Xcurd
  }
}
</script>


// WEBPACK FOOTER //
// order_before.vue?796a474c